// extracted by mini-css-extract-plugin
export default {"back_link":"PlatformSubHeader_back_link__ccaBB","back_link_icon":"PlatformSubHeader_back_link_icon__mHCUg"};